// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"f9e27959","187":"4b21c6aa","524":"de183cce","620":"06998005","899":"3cef8b3d"}[chunkId] + ".chunk.js";
};